module.exports = __webpack_public_path__ + "img/1-detail.81d27f4a.webp";